import React, { Component } from 'react';
import styled from 'styled-components';
import { canBrowserPlayAudio, canBrowserRecordVideo } from '../utils';
import { storeDispatch } from '../state/Store';
import * as Actions from '../state/actions';

const BrowsersContainer = styled.div`
  display: flex;
  margin: 30px 0;
  justify-content: center;
`;

const BrowserIcon = styled.button`
  display: block;
  width: 80px;
  height: 80px;
  margin: 0 10px;
  border-radius: 0;

  background-position: center;
  background-repeat: no-repeat;
  background-size: 60px;
  background-image: url(/media/icons/${props => props.icon});
`;

const Block = styled.div`
  text-align: center;
  margin: 50px 0;

  h1 {
    line-height: 150%;
    margin-bottom: 30px;
  }

  a {
    color: var(--primary-text-color);
  }
`;

const HiddenField = styled.input`
  position: fixed;
  left: -10000px;
`;

export const PartiallySupported = () => {
  const [urlCopied, setUrlCopied] = React.useState(false);
  const hiddenField = React.useRef(null);

  const copyURL = React.useCallback(() => {
    if (hiddenField.current) {
      hiddenField.current.select();
    }
    document.execCommand('copy');
    setUrlCopied(true);
  }, []);

  const doWantToTry = React.useCallback(() => {
    storeDispatch(Actions.closeModal());
  }, []);

  return (
    <div className="overlay not-supported">
      <HiddenField
        ref={hiddenField}
        type="text"
        defaultValue={window.location.href}
      />
      <div>
        <Block>
          <h1>
            Your browser is not fully supported,
            <br />
            it might not be able to record videos or run some effects.
          </h1>
          <button className="large primary" onClick={doWantToTry}>
            Let me try anyway
          </button>
        </Block>
        <Block>
          <h1>To use all the features please download the desktop app</h1>
          <BrowserIcon
            title="Desktop App"
            icon="desktop-app.png"
            style={{
              margin: '0 auto',
              width: 100,
              height: 100,
              backgroundSize: 80
            }}
            onClick={() => (window.location.href = '//beatflyer.com/download')}
          />
          <p style={{ fontSize: 16, lineHeight: '26px', marginTop: 40 }}>
            Or use a recent version of Google Chrome or Firefox.
          </p>
          <BrowsersContainer>
            <BrowserIcon
              title="Google Chrome"
              icon="chrome.svg"
              onClick={() =>
                (window.location.href =
                  'https://www.google.com/chrome/browser/desktop/index.html')
              }
            />
            <BrowserIcon
              title="Mozilla Firefox"
              icon="mozilla_firefox.png"
              onClick={() =>
                (window.location.href = 'https://www.mozilla.org/firefox/')
              }
            />
          </BrowsersContainer>
          <button
            className="medium secondary"
            onClick={copyURL}
            disabled={urlCopied}
          >
            {urlCopied ? 'URL copied into clipboard' : 'Copy website URL'}
          </button>
        </Block>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/not-supported/PartiallySupported.jsx